import { render, staticRenderFns } from "./AvexCoachList.vue?vue&type=template&id=51976088&lang=pug"
import script from "./AvexCoachList.vue?vue&type=script&lang=js"
export * from "./AvexCoachList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports